import axiosInstance from "./axiosInstance";

const userByContact = new Map();

// Looks up the Alfred account behind a phone number, used only to prefill the
// guest form. Results are memoised for the lifetime of the page.
export async function lookupUserByContact(contact) {
    if (!contact) {
        return null;
    }

    const key = String(contact);
    if (userByContact.has(key)) {
        return userByContact.get(key);
    }

    try {
        const response = await axiosInstance.get(`/api/v1/users?contact=${key}`);
        const user = response?.data?.data?.[0] || null;
        userByContact.set(key, user);
        return user;
    } catch (error) {
        console.error("Could not look up user by contact", error);
        return null;
    }
}
